import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'spw-card-excerpt',
  styleUrl: 'spw-card-excerpt.scss',
  shadow: true,
})
export class SpwCardExcerpt {
  /** Permet de limiter ou pas le nombre de lignes affichées */
  @Prop() lineClamp: number | 'none' = 3;

  private get elementClass(): { [className: string]: boolean } {
    const hasLineClamp = this.lineClamp !== 'none';
    return {
      'spw-card-excerpt': true,
      'spw-card-excerpt--has-clamp': hasLineClamp,
      [`spw-card-excerpt--clamp-${this.lineClamp}`]: hasLineClamp,
    };
  }

  render() {
    return (
      <div class={this.elementClass}>
        <slot></slot>
      </div>
    );
  }
}
